<template>
  <svg
    id="Contato_Externo"
    data-name="Interessados"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 235.773 212.661"
  >
    <g
      id="Retângulo_34"
      data-name="Retângulo 34"
      transform="translate(0 36.661)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_35"
      data-name="Retângulo 35"
      width="163"
      height="151"
      transform="translate(38 22.661)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-users"
      data-name="Icon awesome-users"
      d="M35.468,73.185A23.645,23.645,0,1,0,11.823,49.54,23.667,23.667,0,0,0,35.468,73.185Zm82.758,11.823A41.379,41.379,0,1,0,76.847,43.629,41.358,41.358,0,0,0,118.226,85.008ZM146.6,96.831h-3.066a57.13,57.13,0,0,1-50.615,0H89.852A42.572,42.572,0,0,0,47.29,139.392v10.64a17.738,17.738,0,0,0,17.734,17.734h106.4a17.738,17.738,0,0,0,17.734-17.734v-10.64A42.572,42.572,0,0,0,146.6,96.831ZM63.953,91.88A23.576,23.576,0,0,0,47.29,85.008H23.645A23.667,23.667,0,0,0,0,108.653v11.823A11.81,11.81,0,0,0,11.823,132.3H36.17A54.178,54.178,0,0,1,63.953,91.88Z"
      transform="translate(46.611 -2.25)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
